import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShopPlugin } from '@pdqdev/pdq-shared/dist/interfaces';
import { Shop } from '@services/shops/shop.model';
import { ITrackingPage } from '@pdqdev/pdq-shared/dist/interfaces/shopPlugin/ITrackingPage';

@Component({
  selector: 'tracking-page-search-widget',
  templateUrl: './tracking-page-search-widget.component.html',
  styleUrls: ['./tracking-page-search-widget.component.scss', '../../../tracking-page.component.scss'],
  standalone: false,
})
export class TrackingPageSearchWidgetComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  @Input() alignment: 'left' | 'center' | 'right' = 'center';
  @Input() loadedValues: ShopPlugin.TrackingPage.SearchPageWidget;
  @Output() onSearchPagePreviewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() previewButtonState = false;

  VerificationStrategy = ITrackingPage.VerificationStrategy;
  entities: string[];
  dropdownOptions: { label: string; value: string }[] = [
    { label: 'No Extra Verification', value: 'none' },
    {
      label: 'Email only - Customer must enter their email',
      value: ITrackingPage.VerificationStrategy.EMAIL_ONLY,
    },
    {
      label: 'Phone only - Customer must enter their phone number',
      value: ITrackingPage.VerificationStrategy.PHONE_ONLY,
    },
    {
      label: 'Email + phone required',
      value: ITrackingPage.VerificationStrategy.EMAIL_AND_PHONE,
    },
    {
      label: 'Email or phone - Customer can use either one',
      value: ITrackingPage.VerificationStrategy.EMAIL_OR_PHONE,
    },
  ];
  defaultOptionDropdown: { label: string; value: string } | undefined = undefined;

  constructor() {}

  ngOnInit(): void {
    const group = this.formGroup.get('settings')?.get('searchPage') as UntypedFormGroup | undefined;

    if (!group) {
      this.defaultOptionDropdown = { label: 'No Extra Verification', value: 'none' };
      return;
    }

    const verificationStrategy = group.get('verificationStrategy')?.value as ITrackingPage.VerificationStrategy;

    switch (verificationStrategy) {
      case ITrackingPage.VerificationStrategy.EMAIL_AND_PHONE:
        this.defaultOptionDropdown = {
          label: 'Email + phone required',
          value: ITrackingPage.VerificationStrategy.EMAIL_AND_PHONE,
        };
        break;
      case ITrackingPage.VerificationStrategy.EMAIL_OR_PHONE:
        this.defaultOptionDropdown = {
          label: 'Email or phone - Customer can use either one',
          value: ITrackingPage.VerificationStrategy.EMAIL_OR_PHONE,
        };
        break;
      case ITrackingPage.VerificationStrategy.EMAIL_ONLY:
        this.defaultOptionDropdown = {
          label: 'Email only - Customer must enter their email',
          value: ITrackingPage.VerificationStrategy.EMAIL_ONLY,
        };
        break;
      case ITrackingPage.VerificationStrategy.PHONE_ONLY:
        this.defaultOptionDropdown = {
          label: 'Phone only - Customer must enter their phone number',
          value: ITrackingPage.VerificationStrategy.PHONE_ONLY,
        };
        break;
      default:
        this.defaultOptionDropdown = { label: 'No Extra Verification', value: ITrackingPage.VerificationStrategy.NONE };
    }
  }

  previewSearchPageClicked(event: Event) {
    event.stopPropagation();
    this.previewButtonState = !this.previewButtonState;
    this.onSearchPagePreviewChange.next(this.previewButtonState);
    this.formGroup.get('settings.searchPage.titleAlignment')?.setValue(this.alignment);
  }

  setAlignment(align: 'left' | 'center' | 'right') {
    this.alignment = align;
    this.formGroup.get('settings.searchPage.titleAlignment')?.setValue(align);
  }

  applyVerificationMode(strategy: ITrackingPage.VerificationStrategy | undefined) {
    const verificationStrategy = strategy ?? 'none';
    const group = this.formGroup.get('settings.searchPage');

    group?.patchValue({ verificationStrategy });
    group?.get('verificationStrategy')?.markAsDirty();
    group?.markAsDirty();
    this.formGroup.markAsDirty();
  }

  protected readonly FormGroup = UntypedFormGroup;
}
